import i18n from 'i18n-js';

import {
  CountUpBattery,
  CountUpBomb,
  CountUpChristmasBall,
  CountUpChristmasHat,
  CountUpChristmasPresent,
  CountUpDigital,
  CountUpGenshin,
  CountUpGenshinSimple,
  CountUpHalloween,
  CountUpLolWorlds,
  CountUpLolWorldsSimple,
  CountUpMinecraft,
  CountUpNewWorld,
  CountUpSimple,
  CountUpTheGrefg,
  CountUpWithoutBackground,
} from '../../components';

import { TEMPLATES_TITLES } from '../templates';

export const COUNT_UP_COMPONENTS = {
  [TEMPLATES_TITLES.COUNT_UP_BATTERY]: CountUpBattery,
  [TEMPLATES_TITLES.COUNT_UP_BOMB]: CountUpBomb,
  [TEMPLATES_TITLES.COUNT_UP_CHRISTMASBALL]: CountUpChristmasBall,
  [TEMPLATES_TITLES.COUNT_UP_CHRISTMASHAT]: CountUpChristmasHat,
  [TEMPLATES_TITLES.COUNT_UP_CHRISTMASPRESENT]: CountUpChristmasPresent,
  [TEMPLATES_TITLES.COUNT_UP_DIGITAL]: CountUpDigital,
  [TEMPLATES_TITLES.COUNT_UP_GENSHIN]: CountUpGenshin,
  [TEMPLATES_TITLES.COUNT_UP_GENSHINSIMPLE]: CountUpGenshinSimple,
  [TEMPLATES_TITLES.COUNT_UP_HALLOWEEN]: CountUpHalloween,
  [TEMPLATES_TITLES.COUNT_UP_LOLWORLDS]: CountUpLolWorlds,
  [TEMPLATES_TITLES.COUNT_UP_LOLWORLDSSIMPLE]: CountUpLolWorldsSimple,
  [TEMPLATES_TITLES.COUNT_UP_MINECRAFT]: CountUpMinecraft,
  [TEMPLATES_TITLES.COUNT_UP_NEWWORLD]: CountUpNewWorld,
  [TEMPLATES_TITLES.COUNT_UP_SIMPLE]: CountUpSimple,
  [TEMPLATES_TITLES.COUNT_UP_THEGREFG]: CountUpTheGrefg,
  [TEMPLATES_TITLES.COUNT_UP_WITHOUTBACKGROUND]: CountUpWithoutBackground,
};

export const COUNT_UP_DESIGNS_DATA = {
  [TEMPLATES_TITLES.COUNT_UP_BATTERY]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 30,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_BOMB]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 50,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 40,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_CHRISTMASBALL]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 110,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_CHRISTMASHAT]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 60,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 204,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_CHRISTMASPRESENT]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 60,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 204,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_DIGITAL]: {
    design: {
      hasLogo: true,
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 105,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 70,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_GENSHIN]: {
    design: {},
  },
  [TEMPLATES_TITLES.COUNT_UP_GENSHINSIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_HALLOWEEN]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 30,
              max: 90,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_LOLWORLDS]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_LOLWORLDSSIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.logo'),
          value: 'logo',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 301,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_MINECRAFT]: {
    design: {
      hasLogo: true,
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_NEWWORLD]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_THEGREFG]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 204,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.ballsOfPower'),
          value: 'balls',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.visible'),
              type: 'checkbox',
              value: 'show',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNT_UP_WITHOUTBACKGROUND]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
};

export default {
  COUNT_UP_COMPONENTS,
  COUNT_UP_DESIGNS_DATA,
};
